import { jsx } from "panel";
export function template() {
  return /* @__PURE__ */ jsx("div", {
    sel: ".report-header-container"
  }, /* @__PURE__ */ jsx("div", {
    sel: ".report-header-content"
  }, /* @__PURE__ */ jsx("div", {
    sel: ".report-header-title"
  }, this.attr(`title`)), /* @__PURE__ */ jsx("div", {
    sel: ".report-header-description"
  }, this.attr(`description`))), /* @__PURE__ */ jsx("slot", null));
}
